import type { ICellRendererParams } from "ag-grid-community";
import { memo } from "react";

import { Link } from "@/components/Link";

export const ExploreAccessionCell = memo(function ExploreAccessionCell(
  params: ICellRendererParams<Record<string, unknown>, number | string>,
) {
  const value = params.value;
  if (value == null || value === "") return null;

  const id = String(value);

  return (
    <Link to="/accessions/$id" params={{ id }} className="font-medium">
      {id}
    </Link>
  );
});
